// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutHeader-EmptyResultContainer_cls1__rbXUa","cls2":"PayoutHeader-EmptyResultContainer_cls2__cKUhp PayoutHeader-EmptyResultContainer_cls1__rbXUa"};